(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[218],{

/***/ 17494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
;// CONCATENATED MODULE: ./src/components/Checkbox/checkbox.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 25,
  height: 25,
  rx: 4.5,
  fill: "none",
  stroke: "#C6C6C6"
});

function SvgCheckbox({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* harmony default export */ var Checkbox_checkbox = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjI1IiBoZWlnaHQ9IjI1IiByeD0iNC41IiBmaWxsPSJub25lIiBzdHJva2U9IiNDNkM2QzYiLz4KPC9zdmc+Cg==");

;// CONCATENATED MODULE: ./src/components/Checkbox/checkbox-checked.svg
function checkbox_checked_extends() { checkbox_checked_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return checkbox_checked_extends.apply(this, arguments); }



var checkbox_checked_ref = /*#__PURE__*/react.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 25,
  height: 25,
  rx: 4.5,
  fill: "none",
  stroke: "#860935"
});

var _ref2 = /*#__PURE__*/react.createElement("path", {
  d: "M19.6674 8.35674L19.2632 7.95305C18.8195 7.50844 18.0926 7.50844 17.6475 7.95305L10.7859 14.8157L8.35105 12.3818C7.90738 11.9377 7.17999 11.9377 6.73632 12.3823L6.33263 12.7855C5.88896 13.2296 5.88896 13.9565 6.33263 14.4007L9.97613 18.048C10.4203 18.4916 11.1472 18.4916 11.5913 18.048L19.6674 9.97194C20.1106 9.52779 20.1106 8.80088 19.6674 8.35674Z",
  fill: "#860935"
});

function SvgCheckboxChecked({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", checkbox_checked_extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, checkbox_checked_ref, _ref2);
}

/* harmony default export */ var checkbox_checked = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjI1IiBoZWlnaHQ9IjI1IiByeD0iNC41IiBmaWxsPSJub25lIiBzdHJva2U9IiM4NjA5MzUiLz4KICA8cGF0aAogICAgZD0iTTE5LjY2NzQgOC4zNTY3NEwxOS4yNjMyIDcuOTUzMDVDMTguODE5NSA3LjUwODQ0IDE4LjA5MjYgNy41MDg0NCAxNy42NDc1IDcuOTUzMDVMMTAuNzg1OSAxNC44MTU3TDguMzUxMDUgMTIuMzgxOEM3LjkwNzM4IDExLjkzNzcgNy4xNzk5OSAxMS45Mzc3IDYuNzM2MzIgMTIuMzgyM0w2LjMzMjYzIDEyLjc4NTVDNS44ODg5NiAxMy4yMjk2IDUuODg4OTYgMTMuOTU2NSA2LjMzMjYzIDE0LjQwMDdMOS45NzYxMyAxOC4wNDhDMTAuNDIwMyAxOC40OTE2IDExLjE0NzIgMTguNDkxNiAxMS41OTEzIDE4LjA0OEwxOS42Njc0IDkuOTcxOTRDMjAuMTEwNiA5LjUyNzc5IDIwLjExMDYgOC44MDA4OCAxOS42Njc0IDguMzU2NzRaIgogICAgZmlsbD0iIzg2MDkzNSIKICAvPgo8L3N2Zz4K");

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.tsx







const Checkbox = ({
  id,
  checked,
  onChange,
  label
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Component, {
    children: [checked ? /*#__PURE__*/(0,jsx_runtime.jsx)(SvgCheckboxChecked, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(SvgCheckbox, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
      id: id,
      checked: checked,
      type: "checkbox",
      onChange: event => onChange === null || onChange === void 0 ? void 0 : onChange(event.target.checked)
    }), label ? /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
      dangerouslySetInnerHTML: {
        __html: label
      }
    }) : null]
  });
};
const Component = styled_components_browser_esm["default"].label.withConfig({
  displayName: "Checkbox__Component",
  componentId: "sc-113v4uh-0"
})(["position:relative;cursor:pointer;display:flex;align-items:center;"]);
const Input = styled_components_browser_esm["default"].input.withConfig({
  displayName: "Checkbox__Input",
  componentId: "sc-113v4uh-1"
})(["cursor:inherit;position:absolute;opacity:0;width:100%;height:100%;top:0;left:0;margin:0;padding:0;z-index:1;"]);
const Label = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Checkbox__Label",
  componentId: "sc-113v4uh-2"
})(["margin-left:10px;font-size:12px;line-height:16px;position:relative;z-index:2;a{color:", ";text-decoration:underline;&:hover{text-decoration:none;}}"], theme/* colors.primary */.O9.primary);
;// CONCATENATED MODULE: ./src/components/Checkbox/index.ts


/***/ }),

/***/ 30302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ MultiSelect_MultiSelect; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/production/index.js
var production = __webpack_require__(1617);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./src/assets/svg/Modals/close.svg
var Modals_close = __webpack_require__(93245);
// EXTERNAL MODULE: ./src/hooks/useModalsOpen.tsx
var useModalsOpen = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/MultiSelect/MultiSelect.tsx









function MultiSelect({
  closeModal,
  innerProps
}) {
  const {
    options,
    value,
    onChange
  } = innerProps;
  const {
    closeModalState
  } = (0,useModalsOpen/* default */.Z)();

  const isSelected = option => value.value === option.value;

  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Header, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: t('sort.name')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, {
        onClick: () => {
          closeModalState();
          closeModal();
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Content, {
        children: options.map((option, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Item, {
          selected: isSelected(option),
          onClick: () => {
            if (isSelected(option)) {
              return null;
            }

            onChange(option);
            closeModal();
            closeModalState();
          },
          children: option.label
        }, option.value))
      })
    })]
  });
}

/* harmony default export */ var MultiSelect_MultiSelect = (MultiSelect);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MultiSelect__Component",
  componentId: "sc-1vkyzt4-0"
})(["position:relative;width:100vw;height:calc(var(--vh,1) * 100);padding-bottom:20px;overflow:auto;-webkit-overflow-scrolling:touch;background:", ";"], theme/* colors.white */.O9.white);
const Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MultiSelect__Wrapper",
  componentId: "sc-1vkyzt4-1"
})([""]);
const Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MultiSelect__Content",
  componentId: "sc-1vkyzt4-2"
})(["padding:0 15px;margin-top:20px;min-width:320px;& > div:not(:first-child){margin-top:20px;}"]);
const Item = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MultiSelect__Item",
  componentId: "sc-1vkyzt4-3"
})(["display:flex;align-items:center;justify-content:center;height:34px;width:100%;cursor:pointer;font-style:normal;font-weight:500;font-size:13px;line-height:20px;border-radius:5px;transition:background 0.25s ease,color 0.25s ease;", ";&:hover{background:", ";color:", ";}"], ({
  selected
}) => selected ? (0,styled_components_browser_esm.css)(["background:", ";color:", ";"], theme/* colors.primary */.O9.primary, theme/* colors.white */.O9.white) : (0,styled_components_browser_esm.css)(["background:", ";color:", ";"], theme/* colors.gray100 */.O9.gray100, theme/* colors.black */.O9.black), theme/* colors.primary */.O9.primary, theme/* colors.white */.O9.white);
const Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MultiSelect__Header",
  componentId: "sc-1vkyzt4-4"
})(["height:45px;position:relative;padding:5px 15px;display:flex;align-items:center;justify-content:center;box-shadow:0 1px 6px 0 #d0d0d0;"]);
const StyledIcon = (0,styled_components_browser_esm["default"])(Modals_close/* ReactComponent */.r).withConfig({
  displayName: "MultiSelect__StyledIcon",
  componentId: "sc-1vkyzt4-5"
})(["position:absolute;top:50%;right:15px;transform:translateY(-50%);cursor:pointer;margin-left:15px;"]);
const Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MultiSelect__Title",
  componentId: "sc-1vkyzt4-6"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:24px;"]);
;// CONCATENATED MODULE: ./src/components/MultiSelect/index.ts


/***/ }),

/***/ 37941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PageHeader_PageHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/BreadCrumb/index.ts + 2 modules
var BreadCrumb = __webpack_require__(3601);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/PageHeader/PageHeader.tsx





function PageHeader({
  breadCrumbs
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
      breadCrumbs: breadCrumbs
    })
  });
}

/* harmony default export */ var PageHeader_PageHeader = (PageHeader);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PageHeader__Component",
  componentId: "sc-1xtl7uw-0"
})([""]);
;// CONCATENATED MODULE: ./src/components/PageHeader/index.ts


/***/ }),

/***/ 28925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Relations_Relations; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@tager/web-modules/dist/web-modules.esm.js
var web_modules_esm = __webpack_require__(56640);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
// EXTERNAL MODULE: ./src/components/Picture.tsx
var Picture = __webpack_require__(97377);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Relations/Relations.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









function Relations({
  data,
  type
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: data.length > 0 ? data.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
      to: `/catalog${item.urlPath}`,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(RelationsCard, {
        children: [type === 'searchPage' ? /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
          src: item.icon
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, _objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)(item.image))), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
          children: item.name
        })]
      })
    }, item.id)) : null
  });
}

/* harmony default export */ var Relations_Relations = (Relations);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Relations__Component",
  componentId: "sc-1bkl7uj-0"
})(["margin:6px -15px 0;position:relative;padding:12px 15px;display:grid;grid-auto-flow:column;align-items:start;justify-content:start;gap:10px;overflow-x:auto;background:rgb(245,245,245);"]);
const RelationsCard = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Relations__RelationsCard",
  componentId: "sc-1bkl7uj-1"
})(["flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;min-width:140px;height:100%;picture{width:100%;height:100%;}img{height:50px;width:120px;display:block;position:relative;max-height:80px;overflow:hidden;object-fit:contain;margin:0 auto;}& > div:first-child{margin-bottom:12.5px;}"]);
const Description = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Relations__Description",
  componentId: "sc-1bkl7uj-2"
})(["font-style:normal;font-weight:600;font-size:12px;line-height:18px;text-align:center;"]);
;// CONCATENATED MODULE: ./src/components/Relations/index.ts


/***/ }),

/***/ 50589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ QUERY_DEFAULT_VALUES; }
/* harmony export */ });
const QUERY_DEFAULT_VALUES = {
  PageLimit: 5,
  pageOffset: 0
};

/***/ }),

/***/ 34340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tager/web-components/dist/web-components.esm.js
var web_components_esm = __webpack_require__(63394);
// EXTERNAL MODULE: ./src/components/Layout/index.ts
var Layout = __webpack_require__(41880);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/production/index.js
var production = __webpack_require__(1617);
// EXTERNAL MODULE: ./src/components/ContentContainer.tsx
var ContentContainer = __webpack_require__(64283);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/modules/NotFound/NotFound.tsx









function NotFound() {
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Inner, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextError, {
          children: "404"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextPageNotFound, {
          children: t('errors.404_title')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
          to: "/",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonLink, {
            children: t('errors.go_to_home')
          })
        })]
      })
    })
  });
}

/* harmony default export */ var NotFound_NotFound = (NotFound);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "NotFound__Component",
  componentId: "sc-19kmbfl-0"
})(["height:100%;display:flex;align-items:center;"]);
const Inner = styled_components_browser_esm["default"].div.withConfig({
  displayName: "NotFound__Inner",
  componentId: "sc-19kmbfl-1"
})(["text-align:center;padding:20px 0 10px 0;"]);
const TextError = styled_components_browser_esm["default"].h1.withConfig({
  displayName: "NotFound__TextError",
  componentId: "sc-19kmbfl-2"
})(["font-size:44px;margin:0;"]);
const TextPageNotFound = styled_components_browser_esm["default"].h1.withConfig({
  displayName: "NotFound__TextPageNotFound",
  componentId: "sc-19kmbfl-3"
})(["font-size:36px;margin:0 0 30px;"]);
const ButtonLink = styled_components_browser_esm["default"].button.withConfig({
  displayName: "NotFound__ButtonLink",
  componentId: "sc-19kmbfl-4"
})(["border:1px solid ", ";color:", ";font-weight:600;border-radius:5px;width:230px;line-height:38px;&:hover{background:", ";color:", ";}"], theme/* colors.primary */.O9.primary, theme/* colors.primary */.O9.primary, theme/* colors.primary */.O9.primary, theme/* colors.white */.O9.white);
;// CONCATENATED MODULE: ./src/modules/NotFound/index.ts

;// CONCATENATED MODULE: ./src/pages/404.tsx






function NotFoundPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(web_components_esm/* Page */.T3, {
    title: "Page not found",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NotFound_NotFound, {})
    })
  });
}

/* harmony default export */ var _404 = (NotFoundPage);

/***/ }),

/***/ 6386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _alias_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@tager/web-components/dist/web-components.esm.js
var web_components_esm = __webpack_require__(63394);
// EXTERNAL MODULE: ./node_modules/@tager/web-core/dist/web-core.esm.js + 6 modules
var web_core_esm = __webpack_require__(61055);
// EXTERNAL MODULE: ./src/components/Layout/index.ts
var Layout = __webpack_require__(41880);
// EXTERNAL MODULE: ./src/pages/404.tsx + 2 modules
var _404 = __webpack_require__(34340);
// EXTERNAL MODULE: ./src/utils/common.ts
var common = __webpack_require__(29116);
// EXTERNAL MODULE: ./src/pages/_error.tsx
var _error = __webpack_require__(35635);
// EXTERNAL MODULE: ./src/utils/thunks.ts
var thunks = __webpack_require__(26625);
// EXTERNAL MODULE: ./src/store/reducers/pages/catalog/catalog.tsx
var catalog = __webpack_require__(5729);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./src/store/store.ts + 3 modules
var store = __webpack_require__(11402);
// EXTERNAL MODULE: ./src/store/reducers/pages/filters/CatalogProductFilters/filters.ts + 2 modules
var filters = __webpack_require__(56016);
// EXTERNAL MODULE: ./src/constants/search.ts
var search = __webpack_require__(6950);
// EXTERNAL MODULE: ./src/constants/catalog.ts
var constants_catalog = __webpack_require__(50589);
;// CONCATENATED MODULE: ./src/modules/Catalog/types.ts
let CATEGORY_TYPE;

(function (CATEGORY_TYPE) {
  CATEGORY_TYPE["catalog"] = "CATALOG";
  CATEGORY_TYPE["product"] = "PRODUCT";
})(CATEGORY_TYPE || (CATEGORY_TYPE = {}));
// EXTERNAL MODULE: ./node_modules/use-intl/dist/production/index.js
var production = __webpack_require__(1617);
// EXTERNAL MODULE: ./src/components/PageHeader/index.ts + 1 modules
var PageHeader = __webpack_require__(37941);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/modules/Catalog/components/Top/Top.tsx












function Top({
  showPagesAmount,
  count
}) {
  var _currentCategory$data, _currentCategory$data2, _currentCategory$data3;

  const router = (0,next_router.useRouter)();
  const alias = (0,common/* convertAliasToPathQuery */.k6)((0,common/* convertSlugToPath */.L1)(router.query.alias));
  const currentCategory = (0,store/* useTypedSelector */.ix)(state => (0,catalog/* selectCategoryByAlias */.tg)(state, alias));
  const BreadCrumbs = [];
  BreadCrumbs.push({
    label: (_currentCategory$data = currentCategory.data) === null || _currentCategory$data === void 0 ? void 0 : _currentCategory$data.name,
    url: `catalog/${alias}`
  });

  if (!!((_currentCategory$data2 = currentCategory.data) !== null && _currentCategory$data2 !== void 0 && _currentCategory$data2.parents.length)) {
    currentCategory.data.parents.forEach(data => {
      BreadCrumbs.push({
        label: data.name,
        url: data.url
      });
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
      breadCrumbs: BreadCrumbs.reverse()
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Content, {
      children: (_currentCategory$data3 = currentCategory.data) !== null && _currentCategory$data3 !== void 0 && _currentCategory$data3.name ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          children: currentCategory.data.name
        }), showPagesAmount ? /*#__PURE__*/(0,jsx_runtime.jsx)(Count, {
          children: count
        }) : null]
      }) : null
    })]
  });
}

/* harmony default export */ var Top_Top = (Top);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Top__Component",
  componentId: "sc-m6p2xi-0"
})([""]);
const Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Top__Content",
  componentId: "sc-m6p2xi-1"
})(["display:flex;align-items:center;"]);
const Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Top__Title",
  componentId: "sc-m6p2xi-2"
})(["font-style:normal;font-weight:500;font-size:20px;line-height:24px;"]);
const Count = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Top__Count",
  componentId: "sc-m6p2xi-3"
})(["margin-left:12px;font-style:normal;font-weight:600;font-size:12px;line-height:16px;color:", ";"], theme/* colors.gray300 */.O9.gray300);
;// CONCATENATED MODULE: ./src/modules/Catalog/components/Top/index.ts

// EXTERNAL MODULE: ./src/components/Spinner/index.ts + 1 modules
var Spinner = __webpack_require__(66595);
// EXTERNAL MODULE: ./src/components/Relations/index.ts + 1 modules
var Relations = __webpack_require__(28925);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
// EXTERNAL MODULE: ./src/components/Cards/CatalogCard/index.ts + 2 modules
var CatalogCard = __webpack_require__(15860);
// EXTERNAL MODULE: ./src/components/Button/index.ts
var Button = __webpack_require__(91533);
;// CONCATENATED MODULE: ./src/modules/Catalog/components/RelationsExtended/RelationsExtended.tsx








function RelationsExtended({
  data
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RelationsExtended_Component, {
    children: data.map(item => /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubCategory, {
        children: item.name
      }), item.products.slice(0, 2).map(product => /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        to: `/products/${product.urlAlias}`,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogCard/* default */.Z, {
          data: product
        })
      }, product.id)), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, {
        href: item.url,
        variant: "outlined-primary-w100",
        children: item.buttonLabel
      })]
    }, item.id))
  });
}

/* harmony default export */ var RelationsExtended_RelationsExtended = (RelationsExtended);
const RelationsExtended_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RelationsExtended__Component",
  componentId: "sc-nrkjz4-0"
})([""]);
const SubCategory = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RelationsExtended__SubCategory",
  componentId: "sc-nrkjz4-1"
})(["font-style:normal;font-weight:500;font-size:16px;line-height:24px;"]);
const Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RelationsExtended__Wrapper",
  componentId: "sc-nrkjz4-2"
})(["margin-top:30px;display:grid;row-gap:15px;position:relative;min-height:", "px;"], ({
  isForSpinner
}) => isForSpinner ? 352 : 100);
const StyledButton = (0,styled_components_browser_esm["default"])(Button/* ButtonLink */.Z).withConfig({
  displayName: "RelationsExtended__StyledButton",
  componentId: "sc-nrkjz4-3"
})([""]);
;// CONCATENATED MODULE: ./src/assets/svg/Catalog/filter.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 4H8.2C8.6 5.2 9.7 6 11 6C12.3 6 13.4 5.2 13.8 4H15C15.5 4 16 3.5 16 3C16 2.5 15.5 2 15 2H13.8C13.4 0.8 12.3 0 11 0C9.7 0 8.6 0.8 8.2 2H1C0.5 2 0 2.5 0 3C0 3.5 0.5 4 1 4ZM11 2C11.5 2 12 2.5 12 3C12 3.5 11.6 4 11 4C10.4 4 10 3.5 10 3C10 2.5 10.4 2 11 2ZM15 12H13.8C13.4 10.8 12.3 10 11 10C9.7 10 8.6 10.8 8.2 12H1C0.5 12 0 12.4 0 13C0 13.6 0.5 14 1 14H8.2C8.6 15.2 9.7 16 11 16C12.3 16 13.4 15.2 13.8 14H15C15.5 14 16 13.5 16 13C16 12.5 15.5 12 15 12ZM11 14C10.4 14 10 13.5 10 13C10 12.5 10.4 12 11 12C11.5 12 12 12.4 12 13C12 13.6 11.5 14 11 14ZM15 7H7.8C7.4 5.8 6.3 5 5 5C3.7 5 2.6 5.8 2.2 7H1C0.5 7 0 7.4 0 8C0 8.6 0.5 9 1 9H2.2C2.6 10.2 3.7 11 5 11C6.3 11 7.4 10.1 7.8 9C7.9 9 7.9 9 8 9H15C15.5 9 16 8.6 16 8C16 7.4 15.5 7 15 7ZM5 9C4.5 9 4 8.6 4 8C4 7.4 4.5 7 5 7C5.5 7 6 7.4 6 8C6 8.6 5.5 9 5 9Z",
  fill: "#860935"
});

function SvgFilter({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* harmony default export */ var filter = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xIDRIOC4yQzguNiA1LjIgOS43IDYgMTEgNkMxMi4zIDYgMTMuNCA1LjIgMTMuOCA0SDE1QzE1LjUgNCAxNiAzLjUgMTYgM0MxNiAyLjUgMTUuNSAyIDE1IDJIMTMuOEMxMy40IDAuOCAxMi4zIDAgMTEgMEM5LjcgMCA4LjYgMC44IDguMiAySDFDMC41IDIgMCAyLjUgMCAzQzAgMy41IDAuNSA0IDEgNFpNMTEgMkMxMS41IDIgMTIgMi41IDEyIDNDMTIgMy41IDExLjYgNCAxMSA0QzEwLjQgNCAxMCAzLjUgMTAgM0MxMCAyLjUgMTAuNCAyIDExIDJaTTE1IDEySDEzLjhDMTMuNCAxMC44IDEyLjMgMTAgMTEgMTBDOS43IDEwIDguNiAxMC44IDguMiAxMkgxQzAuNSAxMiAwIDEyLjQgMCAxM0MwIDEzLjYgMC41IDE0IDEgMTRIOC4yQzguNiAxNS4yIDkuNyAxNiAxMSAxNkMxMi4zIDE2IDEzLjQgMTUuMiAxMy44IDE0SDE1QzE1LjUgMTQgMTYgMTMuNSAxNiAxM0MxNiAxMi41IDE1LjUgMTIgMTUgMTJaTTExIDE0QzEwLjQgMTQgMTAgMTMuNSAxMCAxM0MxMCAxMi41IDEwLjQgMTIgMTEgMTJDMTEuNSAxMiAxMiAxMi40IDEyIDEzQzEyIDEzLjYgMTEuNSAxNCAxMSAxNFpNMTUgN0g3LjhDNy40IDUuOCA2LjMgNSA1IDVDMy43IDUgMi42IDUuOCAyLjIgN0gxQzAuNSA3IDAgNy40IDAgOEMwIDguNiAwLjUgOSAxIDlIMi4yQzIuNiAxMC4yIDMuNyAxMSA1IDExQzYuMyAxMSA3LjQgMTAuMSA3LjggOUM3LjkgOSA3LjkgOSA4IDlIMTVDMTUuNSA5IDE2IDguNiAxNiA4QzE2IDcuNCAxNS41IDcgMTUgN1pNNSA5QzQuNSA5IDQgOC42IDQgOEM0IDcuNCA0LjUgNyA1IDdDNS41IDcgNiA3LjQgNiA4QzYgOC42IDUuNSA5IDUgOVoiIGZpbGw9IiM4NjA5MzUiLz4KPC9zdmc+Cg==");

// EXTERNAL MODULE: ./src/hooks/useModalsOpen.tsx
var useModalsOpen = __webpack_require__(73637);
// EXTERNAL MODULE: ./src/hooks/useBodyPositionFixed.tsx
var useBodyPositionFixed = __webpack_require__(35535);
// EXTERNAL MODULE: ./src/typings/filter/types.ts
var types = __webpack_require__(26102);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/components/Input/RangeInput.tsx






function RangeInput({
  value,
  mask,
  onChange,
  isOnFocus,
  onBlur
}, ref) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Mask, {
      children: [mask, " "]
    }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
      autoFocus: isOnFocus,
      ref: ref,
      type: "text",
      value: value,
      onChange: event => onChange(event.target.value),
      onBlur: event => {
        onBlur(event.target.value);
      }
    })]
  });
}

/* harmony default export */ var Input_RangeInput = (/*#__PURE__*/react.forwardRef(RangeInput));
const Mask = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RangeInput__Mask",
  componentId: "sc-1qvyo-0"
})(["position:absolute;left:15px;top:50%;transform:translateY(-50%);"]);
const Input = styled_components_browser_esm["default"].input.withConfig({
  displayName: "RangeInput__Input",
  componentId: "sc-1qvyo-1"
})(["padding-left:45px;height:100%;width:100%;outline:none;border:none;"]);
;// CONCATENATED MODULE: ./src/components/Filter/components/Range/types.ts
let ValueRange;

(function (ValueRange) {
  ValueRange["from"] = "valueFrom";
  ValueRange["to"] = "valueTo";
})(ValueRange || (ValueRange = {}));
;// CONCATENATED MODULE: ./src/components/Filter/components/Range/helpers.ts


const handleRange = (field, value, currentValue, type, onChange) => {
  const [min, max] = type === ValueRange.from ? [currentValue, value[1]] : [value[0], currentValue];
  onChange({
    id: field.id,
    type: types/* FilterTypes.Range */.K.Range,
    value: min > max ? [max, min] : [min, max]
  });
};
const getFullWidth = (min, max) => max - min;
const getMargin = (curMin, min, width) => 100 * (curMin - min) / width;
const getWidth = (margin, max, currMax, width) => 100 - margin - (max - currMax) / width * 100;
;// CONCATENATED MODULE: ./src/components/Filter/components/Range/Range.tsx










const Range = ({
  field,
  value,
  onChange
}) => {
  var _field$valueFrom, _field$valueFrom2, _field$valueTo, _field$valueTo2, _field$valueFrom3, _field$valueTo3, _field$rangeFrom, _field$rangeTo, _field$rangeFrom2, _field$rangeTo2;

  const {
    0: minValue,
    1: setMinValue
  } = (0,react.useState)(value[0]);
  const {
    0: maxValue,
    1: setMaxValue
  } = (0,react.useState)(value[1]);
  const {
    0: lastUpdatedInput,
    1: setLastUpdatedInput
  } = (0,react.useState)(null);
  const {
    0: rangeMargin,
    1: setMargin
  } = (0,react.useState)(getMargin(value[0], (_field$valueFrom = field.valueFrom) !== null && _field$valueFrom !== void 0 ? _field$valueFrom : 0, getFullWidth((_field$valueFrom2 = field.valueFrom) !== null && _field$valueFrom2 !== void 0 ? _field$valueFrom2 : 0, (_field$valueTo = field.valueTo) !== null && _field$valueTo !== void 0 ? _field$valueTo : 0)));
  const {
    0: rangeWidth,
    1: setWidth
  } = (0,react.useState)(getWidth(rangeMargin, (_field$valueTo2 = field.valueTo) !== null && _field$valueTo2 !== void 0 ? _field$valueTo2 : 0, value[1], getFullWidth((_field$valueFrom3 = field.valueFrom) !== null && _field$valueFrom3 !== void 0 ? _field$valueFrom3 : 0, (_field$valueTo3 = field.valueTo) !== null && _field$valueTo3 !== void 0 ? _field$valueTo3 : 0)));
  const prevValue = (0,react.useRef)(value);
  const t = (0,production/* useTranslations */.T_)();

  const setFocus = index => lastUpdatedInput !== null && lastUpdatedInput === index;

  const onChangeValue = (inputValue, index) => {
    let fixedValue = Number(inputValue.trim());

    if (!(0,lodash.isNumber)(fixedValue) || (0,lodash.isNaN)(fixedValue)) {
      return null;
    }

    if (field !== null && field !== void 0 && field.valueTo && fixedValue > field.valueTo) {
      fixedValue = index === 0 ? maxValue - 1 : field.valueTo;
    }

    if (index === 0 && fixedValue === minValue) {
      return null;
    }

    index === 0 ? setMinValue(fixedValue) : setMaxValue(fixedValue);
  };

  const onRangeChangeFrom = value => {
    var _field$valueFrom4, _field$valueFrom5, _field$valueTo4;

    const margin = getMargin(minValue, (_field$valueFrom4 = field.valueFrom) !== null && _field$valueFrom4 !== void 0 ? _field$valueFrom4 : 0, getFullWidth((_field$valueFrom5 = field.valueFrom) !== null && _field$valueFrom5 !== void 0 ? _field$valueFrom5 : 0, (_field$valueTo4 = field.valueTo) !== null && _field$valueTo4 !== void 0 ? _field$valueTo4 : 0));
    setMargin(pre => margin);
    setWidth(pre => {
      var _field$valueTo5, _field$valueFrom6, _field$valueTo6;

      return getWidth(margin, (_field$valueTo5 = field.valueTo) !== null && _field$valueTo5 !== void 0 ? _field$valueTo5 : 0, maxValue, getFullWidth((_field$valueFrom6 = field.valueFrom) !== null && _field$valueFrom6 !== void 0 ? _field$valueFrom6 : 0, (_field$valueTo6 = field.valueTo) !== null && _field$valueTo6 !== void 0 ? _field$valueTo6 : 0));
    });
    onChangeValue(value, 0);
  };

  const onRangeChangeTo = value => {
    var _field$valueTo7, _field$valueFrom7, _field$valueTo8;

    onChangeValue(value, 1);
    const width = getWidth(rangeMargin, (_field$valueTo7 = field.valueTo) !== null && _field$valueTo7 !== void 0 ? _field$valueTo7 : 0, maxValue, getFullWidth((_field$valueFrom7 = field.valueFrom) !== null && _field$valueFrom7 !== void 0 ? _field$valueFrom7 : 0, (_field$valueTo8 = field.valueTo) !== null && _field$valueTo8 !== void 0 ? _field$valueTo8 : 0));
    setWidth(width);
    onChangeValue(value, 1);
  };

  (0,react.useLayoutEffect)(() => {
    if (maxValue < minValue) {
      var _field$valueFrom8, _field$valueFrom9, _field$valueFrom10, _field$valueTo9, _field$valueFrom11, _field$valueFrom12, _field$valueFrom13, _field$valueTo10;

      const fixedMaxValue = maxValue > ((_field$valueFrom8 = field.valueFrom) !== null && _field$valueFrom8 !== void 0 ? _field$valueFrom8 : 0) ? maxValue : (_field$valueFrom9 = field.valueFrom) !== null && _field$valueFrom9 !== void 0 ? _field$valueFrom9 : 0;
      const width = (minValue - fixedMaxValue) / getFullWidth((_field$valueFrom10 = field.valueFrom) !== null && _field$valueFrom10 !== void 0 ? _field$valueFrom10 : 0, (_field$valueTo9 = field.valueTo) !== null && _field$valueTo9 !== void 0 ? _field$valueTo9 : 0) * 100;
      const margin = fixedMaxValue > ((_field$valueFrom11 = field.valueFrom) !== null && _field$valueFrom11 !== void 0 ? _field$valueFrom11 : 0) ? (fixedMaxValue - ((_field$valueFrom12 = field.valueFrom) !== null && _field$valueFrom12 !== void 0 ? _field$valueFrom12 : 0)) / getFullWidth((_field$valueFrom13 = field.valueFrom) !== null && _field$valueFrom13 !== void 0 ? _field$valueFrom13 : 0, (_field$valueTo10 = field.valueTo) !== null && _field$valueTo10 !== void 0 ? _field$valueTo10 : 0) * 100 : 0;
      setWidth(prevV => width);
      setMargin(prevV => margin);
    } else {
      var _field$valueTo11, _field$valueFrom14, _field$valueTo12, _field$valueFrom15, _field$valueFrom16, _field$valueFrom17, _field$valueTo13;

      const width = getWidth(rangeMargin, (_field$valueTo11 = field.valueTo) !== null && _field$valueTo11 !== void 0 ? _field$valueTo11 : 0, maxValue, getFullWidth((_field$valueFrom14 = field.valueFrom) !== null && _field$valueFrom14 !== void 0 ? _field$valueFrom14 : 0, (_field$valueTo12 = field.valueTo) !== null && _field$valueTo12 !== void 0 ? _field$valueTo12 : 0));
      const margin = minValue > ((_field$valueFrom15 = field.valueFrom) !== null && _field$valueFrom15 !== void 0 ? _field$valueFrom15 : 0) ? getMargin(minValue, (_field$valueFrom16 = field.valueFrom) !== null && _field$valueFrom16 !== void 0 ? _field$valueFrom16 : 0, getFullWidth((_field$valueFrom17 = field.valueFrom) !== null && _field$valueFrom17 !== void 0 ? _field$valueFrom17 : 0, (_field$valueTo13 = field.valueTo) !== null && _field$valueTo13 !== void 0 ? _field$valueTo13 : 0)) : 0;
      setMargin(preV => margin);
      setWidth(prevV => width);
    }
  }, [field.valueFrom, field.valueTo, maxValue, minValue, rangeMargin]);
  (0,react.useEffect)(() => {
    prevValue.current = value;
  }, [value]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Range_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Range_Content, {
      style: {
        '--range-width': `${rangeWidth}%`,
        '--range-margin': `${rangeMargin}%`
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(RangeWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InputRange, {
          value: minValue,
          type: "range",
          min: (_field$rangeFrom = field.rangeFrom) !== null && _field$rangeFrom !== void 0 ? _field$rangeFrom : 0,
          max: (_field$rangeTo = field.rangeTo) !== null && _field$rangeTo !== void 0 ? _field$rangeTo : 0,
          step: 1,
          onMouseUp: () => {
            handleRange(field, value, minValue, 'valueFrom', onChange);
          },
          onChange: e => {
            onRangeChangeFrom(e.target.value);
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(InputRange, {
          value: maxValue,
          type: "range",
          min: (_field$rangeFrom2 = field.rangeFrom) !== null && _field$rangeFrom2 !== void 0 ? _field$rangeFrom2 : 0,
          max: (_field$rangeTo2 = field.rangeTo) !== null && _field$rangeTo2 !== void 0 ? _field$rangeTo2 : 0,
          step: 1,
          onMouseUp: () => {
            handleRange(field, value, maxValue, 'valueTo', onChange);
          },
          onChange: e => {
            onRangeChangeTo(e.target.value);
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Details, {
        children: value.map((currentValue, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Row, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input_RangeInput, {
            isOnFocus: setFocus(index),
            value: index === 0 ? minValue : maxValue,
            mask: index === 0 ? t('dimensions.from') : t('dimensions.to'),
            onBlur: currentValue => {
              const type = index === 0 ? 'valueFrom' : 'valueTo';
              handleRange(field, value, index === 0 ? minValue : maxValue, type, onChange);
            },
            onChange: currentValue => {
              onChangeValue(currentValue, index);
              setLastUpdatedInput(index);
            }
          })
        }, index))
      })]
    })
  });
};

/* harmony default export */ var Range_Range = (Range);
const Range_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Range__Component",
  componentId: "sc-14tal7h-0"
})(["position:relative;"]);
const Range_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Range__Content",
  componentId: "sc-14tal7h-1"
})([""]);
const Details = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Range__Details",
  componentId: "sc-14tal7h-2"
})(["display:grid;grid-template-columns:1fr 1fr;gap:15px;"]);
const Row = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Range__Row",
  componentId: "sc-14tal7h-3"
})(["position:relative;height:34px;overflow:hidden;border-radius:5px;border:1px solid ", ";"], theme/* colors.gray70 */.O9.gray70);
const RangeWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Range__RangeWrapper",
  componentId: "sc-14tal7h-4"
})(["position:relative;margin:10px 0;height:46px;&:before,&:after{position:absolute;content:'';display:block;top:50%;transform:translateY(-50%);height:5px;border-radius:5px;}&:after{width:var(--range-width,100%);margin-left:var(--range-margin,0);background:", ";}&:before{width:100%;background:", ";}"], theme/* colors.primary */.O9.primary, theme/* colors.gray70 */.O9.gray70);
const InputRange = styled_components_browser_esm["default"].input.withConfig({
  displayName: "Range__InputRange",
  componentId: "sc-14tal7h-5"
})(["position:relative;display:flex;align-items:center;cursor:pointer;height:5px;background:none;border-radius:5px;width:100%;-webkit-appearance:none;pointer-events:none;&:last-child{top:calc(100% - 10px);}&::-webkit-slider-runnable-track{-webkit-appearance:none;}&::-webkit-slider-thumb{position:relative;z-index:1;-webkit-appearance:none;width:28px;height:28px;background:white;border:2px solid ", ";border-radius:50%;pointer-events:all;top:calc(23px - 2px);}&:last-child::-webkit-slider-thumb{top:calc(-23px + 3px);}&::-moz-range-thumb{}"], theme/* colors.primary */.O9.primary);
;// CONCATENATED MODULE: ./src/components/Filter/components/Range/index.ts

;// CONCATENATED MODULE: ./src/components/Input/RadioInput.tsx




function RadioInput() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RadioInput_Component, {});
}

/* harmony default export */ var Input_RadioInput = (RadioInput);
const RadioInput_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RadioInput__Component",
  componentId: "sc-edi03x-0"
})([""]);
;// CONCATENATED MODULE: ./src/components/Filter/components/Radio/Radio.tsx





const Radio = ({
  field
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Radio_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input_RadioInput, {})
  });
};

/* harmony default export */ var Radio_Radio = (Radio);
const Radio_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Radio__Component",
  componentId: "sc-1doo6f6-0"
})(["position:relative;"]);
;// CONCATENATED MODULE: ./src/components/Filter/components/Radio/index.ts

;// CONCATENATED MODULE: ./src/components/Radio/radio.svg
function radio_extends() { radio_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return radio_extends.apply(this, arguments); }



var radio_ref = /*#__PURE__*/react.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 12.5,
  fill: "transparent",
  stroke: "#C6C6C6"
});

function SvgRadio({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", radio_extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, radio_ref);
}

/* harmony default export */ var Radio_radio = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTMiIGN5PSIxMyIgcj0iMTIuNSIgZmlsbD0idHJhbnNwYXJlbnQiIHN0cm9rZT0iI0M2QzZDNiIvPgo8L3N2Zz4K");

;// CONCATENATED MODULE: ./src/components/Radio/radioChecked.svg
function radioChecked_extends() { radioChecked_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return radioChecked_extends.apply(this, arguments); }



var radioChecked_ref = /*#__PURE__*/react.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 12.5,
  fill: "transparent",
  stroke: "#860935"
});

var _ref2 = /*#__PURE__*/react.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 7,
  fill: "#860935"
});

function SvgRadioChecked({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", radioChecked_extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, radioChecked_ref, _ref2);
}

/* harmony default export */ var radioChecked = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTMiIGN5PSIxMyIgcj0iMTIuNSIgZmlsbD0idHJhbnNwYXJlbnQiIHN0cm9rZT0iIzg2MDkzNSIvPgo8Y2lyY2xlIGN4PSIxMyIgY3k9IjEzIiByPSI3IiBmaWxsPSIjODYwOTM1Ii8+Cjwvc3ZnPgo=");

;// CONCATENATED MODULE: ./src/components/Radio/Radio.tsx







const Radio_Radio_Radio = ({
  checked,
  onChange,
  value
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Radio_Radio_Component, {
    children: [checked ? /*#__PURE__*/(0,jsx_runtime.jsx)(SvgRadioChecked, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(SvgRadio, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Radio_Input, {
      type: "radio",
      value: value,
      checked: checked,
      onChange: () => onChange()
    })]
  });
};

/* harmony default export */ var components_Radio_Radio = (Radio_Radio_Radio);
const Radio_Radio_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Radio__Component",
  componentId: "sc-lxtx73-0"
})(["position:relative;cursor:pointer;display:flex;align-items:center;justify-content:center;"]);
const Radio_Input = styled_components_browser_esm["default"].input.withConfig({
  displayName: "Radio__Input",
  componentId: "sc-lxtx73-1"
})(["cursor:inherit;position:absolute;opacity:0;width:100%;height:100%;top:0;left:0;margin:0;padding:0;z-index:1;"]);
;// CONCATENATED MODULE: ./src/components/Radio/index.ts

;// CONCATENATED MODULE: ./src/components/Filter/components/TrueFalse/TrueFalse.tsx








const TrueFalse = ({
  field,
  value,
  onChange
}) => {
  const t = (0,production/* useTranslations */.T_)();

  const handleChange = option => {
    onChange({
      id: field.id,
      type: types/* FilterTypes.TrueFalse */.K.TrueFalse,
      value: option.label === t('dimensions.yes') ? true : option.label === t('dimensions.false') ? false : null
    });
  };

  const filteredFields = [{
    label: t('dimensions.yes'),
    value: 'true'
  }, {
    label: t('dimensions.false'),
    value: 'false'
  }, {
    label: t('dimensions.not_important'),
    value: 'null'
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TrueFalse_Component, {
    children: filteredFields.map(option => {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(OptionComponent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Radio_Radio, {
          checked: String(value) === option.value,
          onChange: () => handleChange(option),
          value: option.value
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
          children: option.label
        })]
      });
    })
  });
};

/* harmony default export */ var TrueFalse_TrueFalse = (TrueFalse);
const TrueFalse_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TrueFalse__Component",
  componentId: "sc-17vc6zw-0"
})(["position:relative;"]);
const OptionComponent = styled_components_browser_esm["default"].label.withConfig({
  displayName: "TrueFalse__OptionComponent",
  componentId: "sc-17vc6zw-1"
})(["cursor:pointer;display:grid;grid-template-columns:auto 1fr;column-gap:1rem;align-items:center;&:not(:last-child){margin-bottom:1rem;}"]);
const Label = styled_components_browser_esm["default"].span.withConfig({
  displayName: "TrueFalse__Label",
  componentId: "sc-17vc6zw-2"
})([""]);
;// CONCATENATED MODULE: ./src/components/Filter/components/TrueFalse/index.ts

// EXTERNAL MODULE: ./src/components/Checkbox/index.ts + 3 modules
var Checkbox = __webpack_require__(17494);
;// CONCATENATED MODULE: ./src/components/Filter/components/MultiSelect/MultiSelect.tsx







const MultiSelect = ({
  field,
  value,
  onChange
}) => {
  const isChecked = option => value.some(id => id === option.id);

  const mapOptionToStore = (values, checked, id) => {
    if (!checked) {
      return values.filter(value => value !== id);
    }

    return [...values, id];
  };

  const handleChange = option => checked => {
    onChange({
      id: field.id,
      type: types/* FilterTypes.MultiSelect */.K.MultiSelect,
      value: mapOptionToStore(value, checked, option.id)
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(MultiSelect_Component, {
    children: field.options.map((option, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(MultiSelect_OptionComponent, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
        checked: isChecked(option),
        onChange: handleChange(option)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MultiSelect_Label, {
        children: option.label
      })]
    }, option.id))
  });
};

/* harmony default export */ var MultiSelect_MultiSelect = (MultiSelect);
const MultiSelect_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MultiSelect__Component",
  componentId: "sc-ztfhkd-0"
})(["position:relative;"]);
const MultiSelect_OptionComponent = styled_components_browser_esm["default"].label.withConfig({
  displayName: "MultiSelect__OptionComponent",
  componentId: "sc-ztfhkd-1"
})(["cursor:pointer;display:grid;grid-template-columns:auto 1fr;column-gap:1rem;align-items:center;&:not(:last-child){margin-bottom:1rem;}"]);
const MultiSelect_Label = styled_components_browser_esm["default"].span.withConfig({
  displayName: "MultiSelect__Label",
  componentId: "sc-ztfhkd-2"
})([""]);
;// CONCATENATED MODULE: ./src/components/Filter/components/MultiSelect/index.ts

;// CONCATENATED MODULE: ./src/components/Filter/helpers.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








const getFields = (field, value, onChange) => {
  switch (field.type) {
    case types/* FilterTypes.Range */.K.Range:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Range_Range, {
        field: field,
        value: value,
        onChange: onChange
      });

    case types/* FilterTypes.Radio */.K.Radio:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Radio_Radio, {
        field: field
      });

    case types/* FilterTypes.TrueFalse */.K.TrueFalse:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(TrueFalse_TrueFalse, {
        field: field,
        value: value,
        onChange: onChange
      });

    case types/* FilterTypes.MultiSelect */.K.MultiSelect:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(MultiSelect_MultiSelect, {
        field: field,
        value: value,
        onChange: onChange
      });

    default:
      return [];
  }
};
const convertFilterFieldsToState = data => {
  return data.reduce((filter, field) => {
    switch (field.type) {
      case FilterTypes.Range:
        filter.push(_objectSpread(_objectSpread({}, field), {}, {
          value: [field.valueFrom, field.valueTo]
        }));
        return filter;

      case FilterTypes.MultiSelect:
        const options = [];
        field.options.forEach((option, index) => {
          if (option.checked) {
            options.push(option.id);
          }
        });
        filter.push(_objectSpread(_objectSpread({}, field), {}, {
          value: options
        }));
        return filter;

      case FilterTypes.TrueFalse:
        filter.push(_objectSpread(_objectSpread({}, field), {}, {
          value: null
        }));
        return filter;

      case FilterTypes.Radio:
        filter.push(_objectSpread(_objectSpread({}, field), {}, {
          value: null
        }));
        return filter;

      default:
        return filter;
    }
  }, []);
};

const getFilterKey = key => `filters[${key}]`;

const convertValuesToString = values => {
  return Object.keys(values).reduce((queryObject, key) => {
    switch (values[key].type) {
      case types/* FilterTypes.Range */.K.Range:
        return values[key].data.length === 0 ? queryObject : _objectSpread(_objectSpread({}, queryObject), {}, {
          [getFilterKey(key)]: values[key].data.join(':')
        });

      case types/* FilterTypes.MultiSelect */.K.MultiSelect:
        return values[key].data && values[key].data.length === 0 ? queryObject : _objectSpread(_objectSpread({}, queryObject), {}, {
          [getFilterKey(key)]: values[key].data.join(',')
        });

      case types/* FilterTypes.TrueFalse */.K.TrueFalse:
        return values[key].data === null ? queryObject : _objectSpread(_objectSpread({}, queryObject), {}, {
          [getFilterKey(key)]: values[key].data
        });

      case types/* FilterTypes.Radio */.K.Radio:
        return _objectSpread(_objectSpread({}, queryObject), {}, {
          [getFilterKey(key)]: values[key].data
        });

      default:
        return queryObject;
    }
  }, {});
};
;// CONCATENATED MODULE: ./src/components/Button/ResetButton.tsx


const ResetButton_Component = styled_components_browser_esm["default"].button.withConfig({
  displayName: "ResetButton__Component",
  componentId: "sc-cite9x-0"
})(["position:absolute;left:15px;top:50%;transform:translateY(-50%);max-width:90px;padding:4px 10px 3px 11px;font-style:normal;font-weight:500;font-size:12px;line-height:18px;border:1px solid #c6c6c6;border-radius:5px;color:#5b5b5b;"]);
function ResetButton({
  label,
  onClick
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ResetButton_Component, {
    onClick: onClick,
    children: label
  });
}
// EXTERNAL MODULE: ./src/assets/svg/Modals/close.svg
var Modals_close = __webpack_require__(93245);
;// CONCATENATED MODULE: ./src/components/Filter/components/Header/Header.tsx









function Header({
  closeModal,
  onReset
}) {
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Header_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ResetButton, {
      label: t('filter.reset'),
      onClick: onReset
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header_Title, {
      children: t('filter.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, {
      onClick: closeModal
    })]
  });
}

/* harmony default export */ var Header_Header = (Header);
const Header_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Header__Component",
  componentId: "sc-18hfkzs-0"
})(["z-index:5;position:sticky;top:0;height:45px;padding:5px 15px;display:flex;align-items:center;justify-content:center;box-shadow:0 1px 6px 0 #d0d0d0;background:", ";"], theme/* colors.white */.O9.white);
const Header_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Header__Title",
  componentId: "sc-18hfkzs-1"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:24px;"]);
const StyledIcon = (0,styled_components_browser_esm["default"])(Modals_close/* ReactComponent */.r).withConfig({
  displayName: "Header__StyledIcon",
  componentId: "sc-18hfkzs-2"
})(["position:absolute;top:50%;right:15px;transform:translateY(-50%);cursor:pointer;margin-left:15px;"]);
;// CONCATENATED MODULE: ./src/components/Filter/components/Header/index.ts

// EXTERNAL MODULE: ./src/components/ContentContainer.tsx
var ContentContainer = __webpack_require__(64283);
;// CONCATENATED MODULE: ./src/components/Filter/FilterView.tsx










const FilterView = ({
  fields,
  values,
  closeModal,
  onChange,
  onSubmit,
  onReset
}) => {
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FilterView_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header_Header, {
      onReset: onReset,
      closeModal: closeModal
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Main, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
        children: [fields.map(field => /*#__PURE__*/(0,jsx_runtime.jsxs)(Field, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterView_Label, {
            children: field.label
          }), getFields(field, values[field.id].data, onChange)]
        }, field.id)), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FilterView_StyledButton, {
            onClick: onSubmit,
            width: "100%",
            variant: "outlined-primary-w100-f13",
            children: t('filter.apply')
          })
        })]
      })
    })]
  });
};
const FilterView_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FilterView__Component",
  componentId: "sc-cer3le-0"
})(["position:relative;overflow:auto;-webkit-overflow-scrolling:touch;background:white;height:calc(var(--vh,1) * 100);width:100vw;"]);
const Main = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FilterView__Main",
  componentId: "sc-cer3le-1"
})(["position:relative;"]);
const FilterView_StyledButton = (0,styled_components_browser_esm["default"])(Button/* default */.C).withConfig({
  displayName: "FilterView__StyledButton",
  componentId: "sc-cer3le-2"
})([""]);
const Footer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FilterView__Footer",
  componentId: "sc-cer3le-3"
})(["margin-top:15px;background:", ";padding:15px 0;position:sticky;bottom:0;z-index:1;"], theme/* colors.white */.O9.white);
const Field = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FilterView__Field",
  componentId: "sc-cer3le-4"
})(["margin-top:20px;"]);
const FilterView_Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FilterView__Label",
  componentId: "sc-cer3le-5"
})(["margin-bottom:10px;font-style:normal;font-weight:600;font-size:14px;line-height:18px;"]);
;// CONCATENATED MODULE: ./src/components/Filter/Filter.tsx


function Filter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Filter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Filter_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Filter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












const Filter = ({
  innerProps,
  closeModal
}) => {
  const {
    productId,
    productAlias
  } = innerProps;
  const router = (0,next_router.useRouter)();
  const dispatch = (0,es/* useDispatch */.I0)();
  const fields = (0,store/* useTypedSelector */.ix)((0,filters/* selectProductFiltersByProductId */.sy)(productId));
  const values = (0,store/* useTypedSelector */.ix)((0,filters/* selectFiltersValues */.Ne)(productId));
  (0,useBodyPositionFixed/* useBodyPositionFixed */.I)();

  const onSubmit = () => {
    const filters = convertValuesToString(values);
    router.replace({
      query: Filter_objectSpread(Filter_objectSpread(Filter_objectSpread({}, {
        [search/* DEFAULT_SEARCH_PARAMS.PAGE */.qA.PAGE]: search/* DEFAULT_SEARCH_PARAMS_VALUES */.SZ[search/* DEFAULT_SEARCH_PARAMS.PAGE */.qA.PAGE]
      }), router.query), filters)
    }, undefined, {
      shallow: true
    });
    dispatch((0,catalog/* getCategoryProductsByIdThunk */.OY)(productAlias, productId, Filter_objectSpread(Filter_objectSpread({}, filters), search/* DEFAULT_SEARCH_PARAMS_VALUES */.SZ)));
    dispatch((0,catalog/* currentPageAdded */.uC)(1));
    closeModal();
  };

  const onChange = react.useCallback(({
    id,
    value,
    type
  }) => {
    dispatch((0,filters/* updateFilterValueByProductIdAndFilterId */.M9)({
      productId,
      filterId: id,
      value: {
        data: value,
        type
      }
    }));
  }, [dispatch, productId]);
  const onReset = react.useCallback(() => {
    const pathname = window.location.pathname;
    router.replace(pathname, undefined, {
      shallow: true
    });
    dispatch((0,catalog/* getCategoryProductsByIdThunk */.OY)(productAlias, productId));
    dispatch((0,filters/* resetFiltersValues */.XL)({
      productId
    }));
    closeModal();
  }, [closeModal, dispatch, productAlias, productId, router]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FilterView, {
    fields: fields,
    values: values,
    closeModal: closeModal,
    onChange: onChange,
    onSubmit: onSubmit,
    onReset: onReset
  });
};
;// CONCATENATED MODULE: ./src/modules/Catalog/components/Filter/FilterBtn/FilterBtn.tsx










const FilterBtn = ({
  productId,
  productsCount,
  productAlias
}) => {
  const openModal = (0,web_components_esm/* useModal */.dd)();
  const {
    openModalState
  } = (0,useModalsOpen/* default */.Z)();

  const onClick = () => {
    openModalState();
    openModal(Filter, {
      productId,
      productsCount,
      productAlias
    }, {
      withAnimation: false,
      scrollLockDisabled: true
    });
  };

  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FilterBtn_Component, {
    onClick: onClick,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgFilter, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterBtn_Title, {
      children: t('filter.title')
    })]
  });
};

const FilterBtn_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FilterBtn__Component",
  componentId: "sc-w1rcyv-0"
})(["cursor:pointer;display:flex;align-items:center;justify-content:center;padding:8px 16px;border:1px solid #860935;box-sizing:border-box;border-radius:5px;"]);
const Icon = styled_components_browser_esm["default"].span.withConfig({
  displayName: "FilterBtn__Icon",
  componentId: "sc-w1rcyv-1"
})(["line-height:0;"]);
const FilterBtn_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FilterBtn__Title",
  componentId: "sc-w1rcyv-2"
})(["font-style:normal;font-weight:500;font-size:13px;line-height:16px;text-align:center;color:#870a36;margin-left:9px;"]);
/* harmony default export */ var FilterBtn_FilterBtn = (FilterBtn);
;// CONCATENATED MODULE: ./src/modules/Catalog/components/Filter/FilterBtn/index.ts

;// CONCATENATED MODULE: ./src/assets/svg/Catalog/sort.svg
function sort_extends() { sort_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sort_extends.apply(this, arguments); }



var sort_ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 0H1C0.4 0 0 0.4 0 1C0 1.6 0.4 2 1 2H15C15.6 2 16 1.6 16 1C16 0.4 15.6 0 15 0Z",
  fill: "#860935"
});

var sort_ref2 = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.3 6H0.8C0.3 6 0 6.4 0 7C0 7.6 0.3 8 0.8 8H11.3C11.7 8 12 7.6 12 7C12 6.4 11.7 6 11.3 6Z",
  fill: "#860935"
});

var _ref3 = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.1 12H0.9C0.7 12 0.5 12.4 0.5 13C0.5 13.6 0.7 14 0.9 14H7C7.2 14 7.4 13.6 7.4 13C7.4 12.4 7.3 12 7.1 12Z",
  fill: "#860935"
});

function SvgSort({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", sort_extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, sort_ref, sort_ref2, _ref3);
}

/* harmony default export */ var sort = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNSAwSDFDMC40IDAgMCAwLjQgMCAxQzAgMS42IDAuNCAyIDEgMkgxNUMxNS42IDIgMTYgMS42IDE2IDFDMTYgMC40IDE1LjYgMCAxNSAwWiIgZmlsbD0iIzg2MDkzNSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjMgNkgwLjhDMC4zIDYgMCA2LjQgMCA3QzAgNy42IDAuMyA4IDAuOCA4SDExLjNDMTEuNyA4IDEyIDcuNiAxMiA3QzEyIDYuNCAxMS43IDYgMTEuMyA2WiIgZmlsbD0iIzg2MDkzNSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuMSAxMkgwLjlDMC43IDEyIDAuNSAxMi40IDAuNSAxM0MwLjUgMTMuNiAwLjcgMTQgMC45IDE0SDdDNy4yIDE0IDcuNCAxMy42IDcuNCAxM0M3LjQgMTIuNCA3LjMgMTIgNy4xIDEyWiIgZmlsbD0iIzg2MDkzNSIvPgo8L3N2Zz4K");

// EXTERNAL MODULE: ./src/components/MultiSelect/index.ts + 1 modules
var components_MultiSelect = __webpack_require__(30302);
// EXTERNAL MODULE: ./src/constants/sort.ts
var constants_sort = __webpack_require__(54582);
;// CONCATENATED MODULE: ./src/modules/Catalog/components/Filter/SortBtn/SortBtn.tsx


function SortBtn_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SortBtn_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SortBtn_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SortBtn_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















const SortBtn = ({
  alias,
  productId
}) => {
  var _getQueryParams;

  const t = (0,production/* useTranslations */.T_)();
  const OPTIONS = (0,constants_sort/* getOptions */.F)(t);
  const {
    0: selectedOption,
    1: setSelectedOption
  } = (0,react.useState)(OPTIONS[0]);
  const dispatch = (0,es/* useDispatch */.I0)();
  const router = (0,next_router.useRouter)();
  const openModal = (0,web_components_esm/* useModal */.dd)();
  const {
    openModalState
  } = (0,useModalsOpen/* default */.Z)();
  const sortParam = (_getQueryParams = (0,common/* getQueryParams */.vl)()) === null || _getQueryParams === void 0 ? void 0 : _getQueryParams[search/* DEFAULT_SEARCH_PARAMS.SORT */.qA.SORT];
  const currentPage = (0,store/* useTypedSelector */.ix)(catalog/* selectCurrentPage */.Q$);

  const onChange = option => {
    const params = SortBtn_objectSpread(SortBtn_objectSpread({}, (0,common/* getQueryParams */.vl)()), {}, {
      [search/* DEFAULT_SEARCH_PARAMS.PAGE_LIMIT */.qA.PAGE_LIMIT]: constants_catalog/* QUERY_DEFAULT_VALUES.PageLimit */.q.PageLimit,
      [search/* DEFAULT_SEARCH_PARAMS.PAGE_OFF_SET */.qA.PAGE_OFF_SET]: constants_catalog/* QUERY_DEFAULT_VALUES.PageLimit */.q.PageLimit * (currentPage - 1)
    });

    if (params[search/* DEFAULT_SEARCH_PARAMS.SORT */.qA.SORT] === option.value) {
      return null;
    }

    params[search/* DEFAULT_SEARCH_PARAMS.SORT */.qA.SORT] = option.value;
    router.replace({
      query: SortBtn_objectSpread(SortBtn_objectSpread({}, router.query), {
        [search/* DEFAULT_SEARCH_PARAMS.SORT */.qA.SORT]: option.value
      })
    }, undefined, {
      shallow: true
    });
    setSelectedOption(option);
    dispatch((0,catalog/* getCategoryProductsByIdThunk */.OY)(alias, productId, params));
  };

  (0,react.useEffect)(() => {
    const currentSortOption = OPTIONS.find(option => option.value === sortParam);

    if (currentSortOption) {
      setSelectedOption(currentSortOption);
    }
  }, [sortParam]);

  const openSort = () => {
    openModalState();
    openModal(components_MultiSelect/* default */.Z, {
      options: OPTIONS,
      onChange,
      value: selectedOption,
      alias
    }, {
      withAnimation: false
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SortBtn_Component, {
    onClick: openSort,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SortBtn_Icon, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgSort, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SortBtn_Title, {
      children: t('sort.name')
    })]
  });
};

const SortBtn_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SortBtn__Component",
  componentId: "sc-1li9st2-0"
})(["&:hover{}cursor:pointer;display:flex;align-items:center;justify-content:center;padding:8px 16px;border:1px solid #860935;box-sizing:border-box;border-radius:5px;"]);
const SortBtn_Icon = styled_components_browser_esm["default"].span.withConfig({
  displayName: "SortBtn__Icon",
  componentId: "sc-1li9st2-1"
})(["line-height:0;"]);
const SortBtn_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SortBtn__Title",
  componentId: "sc-1li9st2-2"
})(["font-style:normal;font-weight:500;font-size:13px;line-height:16px;text-align:center;color:#870a36;margin-left:9px;"]);
/* harmony default export */ var SortBtn_SortBtn = (SortBtn);
;// CONCATENATED MODULE: ./src/modules/Catalog/components/Filter/SortBtn/index.ts

// EXTERNAL MODULE: ./src/components/Pagination/index.ts + 2 modules
var Pagination = __webpack_require__(89875);
;// CONCATENATED MODULE: ./src/modules/Catalog/CatalogView.tsx




















function CatalogView({
  alias,
  isEmptyCatalog,
  category,
  pageAmount,
  activePage,
  relationsExtended,
  relations,
  products,
  onChange
}) {
  var _products$meta, _category$data, _category$data2, _relationsExtended$da, _category$data3, _relations$data, _category$data$id, _category$data4, _products$data, _category$data$id2, _category$data5, _category$data6, _category$data$conten, _category$data7;

  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogView_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Top_Top, {
        count: products === null || products === void 0 ? void 0 : (_products$meta = products.meta) === null || _products$meta === void 0 ? void 0 : _products$meta.total,
        showPagesAmount: ((_category$data = category.data) === null || _category$data === void 0 ? void 0 : _category$data.type) === CATEGORY_TYPE.product
      }), (relations === null || relations === void 0 ? void 0 : relations.status) === web_core_esm.FETCH_STATUSES.LOADING ? /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWrapper, {
        isRelations: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
      }) : (relations === null || relations === void 0 ? void 0 : relations.status) === web_core_esm.FETCH_STATUSES.SUCCESS && relations.data && relations.data.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Relations/* default */.Z, {
        data: relations.data
      }), (category === null || category === void 0 ? void 0 : (_category$data2 = category.data) === null || _category$data2 === void 0 ? void 0 : _category$data2.type) === 'CATALOG' && ((relationsExtended === null || relationsExtended === void 0 ? void 0 : relationsExtended.status) === web_core_esm.FETCH_STATUSES.LOADING ? /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
      }) : (relationsExtended === null || relationsExtended === void 0 ? void 0 : relationsExtended.status) === web_core_esm.FETCH_STATUSES.SUCCESS && (relationsExtended === null || relationsExtended === void 0 ? void 0 : relationsExtended.data) && relationsExtended.data.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(RelationsExtended_RelationsExtended, {
        data: (_relationsExtended$da = relationsExtended === null || relationsExtended === void 0 ? void 0 : relationsExtended.data) !== null && _relationsExtended$da !== void 0 ? _relationsExtended$da : []
      })), (category === null || category === void 0 ? void 0 : (_category$data3 = category.data) === null || _category$data3 === void 0 ? void 0 : _category$data3.type) === 'PRODUCT' && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RelationsShortLinkList, {
          children: relations === null || relations === void 0 ? void 0 : (_relations$data = relations.data) === null || _relations$data === void 0 ? void 0 : _relations$data.map(link => /*#__PURE__*/(0,jsx_runtime.jsx)(LinkItem, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
              to: '/catalog/' + link.urlPath,
              children: link.name
            })
          }, link.id))
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Filters, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterBtn_FilterBtn, {
            productId: (_category$data$id = category === null || category === void 0 ? void 0 : (_category$data4 = category.data) === null || _category$data4 === void 0 ? void 0 : _category$data4.id) !== null && _category$data$id !== void 0 ? _category$data$id : 0,
            productAlias: alias,
            productsCount: products === null || products === void 0 ? void 0 : (_products$data = products.data) === null || _products$data === void 0 ? void 0 : _products$data.length
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SortBtn_SortBtn, {
            alias: alias,
            productId: (_category$data$id2 = category === null || category === void 0 ? void 0 : (_category$data5 = category.data) === null || _category$data5 === void 0 ? void 0 : _category$data5.id) !== null && _category$data$id2 !== void 0 ? _category$data$id2 : 0
          })]
        })]
      }), ((_category$data6 = category.data) === null || _category$data6 === void 0 ? void 0 : _category$data6.type) === 'PRODUCT' && (products === null || products === void 0 ? void 0 : products.status) === web_core_esm.FETCH_STATUSES.LOADING ? /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWrapper, {
        children: (0,web_core_esm.generateNumberArray)(5).map(elem => /*#__PURE__*/(0,jsx_runtime.jsx)(ProductsSpinnerWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
        }, elem))
      }) : (products === null || products === void 0 ? void 0 : products.status) === web_core_esm.FETCH_STATUSES.SUCCESS && products.data && products.data.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWrapper, {
        children: products === null || products === void 0 ? void 0 : products.data.map(product => /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
          to: `/products/${product.urlAlias}`,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogCard/* default */.Z, {
            data: product
          })
        }, product.id))
      }), isEmptyCatalog ? /*#__PURE__*/(0,jsx_runtime.jsx)(PlaceholderLabel, {
        children: t('search.products_not_found')
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationWrapper, {
        className: "catalog-pagination-wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Pagination/* default */.Z, {
          className: "catalog-pagination",
          current: activePage,
          pageSize: constants_catalog/* QUERY_DEFAULT_VALUES.PageLimit */.q.PageLimit,
          onChange: onChange,
          count: pageAmount
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogView_Content, {
        dangerouslySetInnerHTML: {
          __html: (_category$data$conten = category === null || category === void 0 ? void 0 : (_category$data7 = category.data) === null || _category$data7 === void 0 ? void 0 : _category$data7.content) !== null && _category$data$conten !== void 0 ? _category$data$conten : ''
        }
      })]
    })
  });
}

/* harmony default export */ var Catalog_CatalogView = (CatalogView);
const CatalogView_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogView__Component",
  componentId: "sc-1lvyj36-0"
})([""]);
const ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogView__ContentWrapper",
  componentId: "sc-1lvyj36-1"
})(["display:grid;row-gap:15px;margin-top:30px;position:relative;", " .catalog-spinner{height:352px;}", ""], ({
  isForProducts
}) => isForProducts ? (0,styled_components_browser_esm.css)(["min-height:auto;"]) : (0,styled_components_browser_esm.css)(["min-height:100px;"]), ({
  isRelations
}) => isRelations ? (0,styled_components_browser_esm.css)(["margin:6px -15px 0;background:rgb(245,245,245);"]) : null);
const CatalogView_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogView__Content",
  componentId: "sc-1lvyj36-2"
})(["margin-top:30px;& > p:not(:first-child){margin-top:20px;}"]);
const PlaceholderLabel = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogView__PlaceholderLabel",
  componentId: "sc-1lvyj36-3"
})(["padding:70px 0;text-align:center;font-size:18px;font-weight:500;line-height:30px;"]);
const Filters = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogView__Filters",
  componentId: "sc-1lvyj36-4"
})(["display:grid;grid-template-columns:1fr 1fr;gap:10px;max-width:768px;margin:12px auto 0;"]);
const RelationsShortLinkList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "CatalogView__RelationsShortLinkList",
  componentId: "sc-1lvyj36-5"
})(["margin-top:10px;"]);
const LinkItem = styled_components_browser_esm["default"].li.withConfig({
  displayName: "CatalogView__LinkItem",
  componentId: "sc-1lvyj36-6"
})(["font-weight:600;font-size:13px;&:not(:first-child){margin-top:8px;}"]);
const PaginationWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogView__PaginationWrapper",
  componentId: "sc-1lvyj36-7"
})(["margin-top:30px;"]);
const ProductsSpinnerWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogView__ProductsSpinnerWrapper",
  componentId: "sc-1lvyj36-8"
})(["position:relative;display:flex;justify-content:center;align-items:center;height:382px;"]);
;// CONCATENATED MODULE: ./src/modules/Catalog/helpers.ts

const usePrevTotal = amount => {
  const ref = (0,react.useRef)(amount);
  (0,react.useEffect)(() => {
    if (!isNaN(Number(amount)) && amount !== ref.current) {
      ref.current = amount;
    }
  }, [amount]);
  return ref.current;
};
;// CONCATENATED MODULE: ./src/modules/Catalog/Catalog.tsx


function Catalog_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Catalog_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Catalog_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Catalog_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

















function Catalog() {
  var _products$meta, _ref, _products$meta2, _products$meta3, _products$meta4, _currentCategory$data3, _currentCategory$data4;

  const dispatch = (0,es/* useDispatch */.I0)();
  const router = (0,next_router.useRouter)();
  const activePage = (0,store/* useTypedSelector */.ix)(catalog/* selectCurrentPage */.Q$);
  const alias = (0,common/* convertAliasToPathQuery */.k6)((0,common/* convertSlugToPath */.L1)(router.query.alias));
  const currentCategory = (0,store/* useTypedSelector */.ix)(state => (0,catalog/* selectCategoryByAlias */.tg)(state, alias));
  const relations = (0,store/* useTypedSelector */.ix)(state => (0,catalog/* selectCategoryRelationsByAlias */.hC)(state, alias));
  const relationsExtended = (0,store/* useTypedSelector */.ix)(state => (0,catalog/* selectCategoryRelationsExtendedByAlias */.JP)(state, alias));
  const products = (0,store/* useTypedSelector */.ix)(state => (0,catalog/* selectCategoryProductsByAlias */.Ll)(state, alias));
  const prevPagesAmount = usePrevTotal(products === null || products === void 0 ? void 0 : (_products$meta = products.meta) === null || _products$meta === void 0 ? void 0 : _products$meta.total);
  const pageAmount = (_ref = (products === null || products === void 0 ? void 0 : products.status) === web_core_esm.FETCH_STATUSES.LOADING ? prevPagesAmount : products === null || products === void 0 ? void 0 : (_products$meta2 = products.meta) === null || _products$meta2 === void 0 ? void 0 : _products$meta2.total) !== null && _ref !== void 0 ? _ref : 0;
  const isEmptyCatalog = (products === null || products === void 0 ? void 0 : products.status) === web_core_esm.FETCH_STATUSES.SUCCESS && (products === null || products === void 0 ? void 0 : (_products$meta3 = products.meta) === null || _products$meta3 === void 0 ? void 0 : _products$meta3.total) && products.meta.total > 0 && products.data.length === 0 || (products === null || products === void 0 ? void 0 : (_products$meta4 = products.meta) === null || _products$meta4 === void 0 ? void 0 : _products$meta4.total) === 0;

  const onPageChange = page => {
    var _currentCategory$data;

    const params = {
      [search/* DEFAULT_SEARCH_PARAMS.PAGE_LIMIT */.qA.PAGE_LIMIT]: constants_catalog/* QUERY_DEFAULT_VALUES.PageLimit */.q.PageLimit,
      [search/* DEFAULT_SEARCH_PARAMS.PAGE_OFF_SET */.qA.PAGE_OFF_SET]: constants_catalog/* QUERY_DEFAULT_VALUES.PageLimit */.q.PageLimit * (page - 1),
      [search/* DEFAULT_SEARCH_PARAMS.PAGE */.qA.PAGE]: page
    };

    if ((_currentCategory$data = currentCategory.data) !== null && _currentCategory$data !== void 0 && _currentCategory$data.id) {
      dispatch((0,catalog/* getCategoryProductsByIdThunk */.OY)(alias, currentCategory.data.id, Catalog_objectSpread(Catalog_objectSpread({}, (0,common/* getQueryParams */.vl)()), params)));
      router.replace({
        query: Catalog_objectSpread(Catalog_objectSpread({}, router.query), {}, {
          [search/* DEFAULT_SEARCH_PARAMS.PAGE */.qA.PAGE]: page
        })
      }, undefined, {
        scroll: true,
        shallow: true
      });
      dispatch((0,catalog/* currentPageAdded */.uC)(page));
    }
  };

  (0,react.useEffect)(() => {
    var _currentCategory$data2, _getQueryParams;

    if (!((_currentCategory$data2 = currentCategory.data) !== null && _currentCategory$data2 !== void 0 && _currentCategory$data2.id) || !(0,web_core_esm.isBrowser)()) {
      return;
    }

    switch (currentCategory.data.type) {
      case CATEGORY_TYPE.catalog:
        dispatch((0,catalog/* getCategoryRelationsByIdThunk */.kC)(alias, currentCategory.data.id));
        dispatch((0,catalog/* getcategoryRelationsExtendedByIdThunk */.Zw)(alias, currentCategory.data.id));
        break;

      case CATEGORY_TYPE.product:
        const params = (_getQueryParams = (0,common/* getQueryParams */.vl)()) !== null && _getQueryParams !== void 0 ? _getQueryParams : {};
        const pageFromUrl = params[search/* DEFAULT_SEARCH_PARAMS.PAGE */.qA.PAGE];

        if (pageFromUrl) {
          params[search/* DEFAULT_SEARCH_PARAMS.PAGE_OFF_SET */.qA.PAGE_OFF_SET] = String(constants_catalog/* QUERY_DEFAULT_VALUES.PageLimit */.q.PageLimit * (Number(pageFromUrl) - 1));
          dispatch((0,catalog/* currentPageAdded */.uC)(Number(pageFromUrl)));
        }

        dispatch((0,catalog/* currentPageAdded */.uC)(Number(1)));
        dispatch((0,catalog/* getCategoryProductsByIdThunk */.OY)(alias, currentCategory.data.id, params));
        dispatch((0,filters/* fetchProductFiltersByProductIdThunk */.uk)(currentCategory.data.id));
        break;

      default:
        break;
    }

    return () => {
      dispatch((0,catalog/* currentPageAdded */.uC)(1));
    };
  }, [alias, (_currentCategory$data3 = currentCategory.data) === null || _currentCategory$data3 === void 0 ? void 0 : _currentCategory$data3.id, (_currentCategory$data4 = currentCategory.data) === null || _currentCategory$data4 === void 0 ? void 0 : _currentCategory$data4.type, dispatch]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Catalog_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Catalog_CatalogView, {
      alias: alias,
      category: currentCategory,
      relations: relations,
      relationsExtended: relationsExtended,
      products: products,
      pageAmount: pageAmount,
      activePage: activePage,
      isEmptyCatalog: isEmptyCatalog,
      onChange: onPageChange
    })
  });
}

const Catalog_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Catalog__Component",
  componentId: "sc-hnc8o2-0"
})([""]);
/* harmony default export */ var Catalog_Catalog = (Catalog);
;// CONCATENATED MODULE: ./src/modules/Catalog/index.ts

;// CONCATENATED MODULE: ./src/pages/catalog/[...alias].tsx


function _alias_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _alias_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { _alias_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { _alias_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














function CatalogPage(Props) {
  var _Props$category, _Props$category2;

  const router = (0,next_router.useRouter)();

  if (Props.pageType === 'NOT_FOUND') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_404["default"], {});
  }

  if (Props.pageType === 'ERROR_PAGE') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_error["default"], _alias_objectSpread({}, (0,common/* convertErrorToProps */.g1)(Props.error)));
  }

  const currentPath = (0,common/* getCurrentPath */.b$)(router);
  const cannonicalPath = "https://dverione.com.ua" + currentPath;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(web_components_esm/* Page */.T3, {
    title: (_Props$category = Props.category) === null || _Props$category === void 0 ? void 0 : _Props$category.pageTitle,
    description: (_Props$category2 = Props.category) === null || _Props$category2 === void 0 ? void 0 : _Props$category2.pageDescription,
    canonicalUrl: cannonicalPath,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Catalog_Catalog, {})
    })
  });
}

/* harmony default export */ var _alias_ = (CatalogPage);

CatalogPage.getInitialProps = async ({
  res,
  query,
  store
}) => {
  try {
    const alias = (0,common/* convertAliasToPathQuery */.k6)((0,common/* convertSlugToPath */.L1)(query.alias));
    await store.dispatch((0,catalog/* getCategoryByAliasThunk */.Gc)(alias));
    const categoryResourceDate = (0,catalog/* selectCategoryByAlias */.tg)(store.getState(), alias);

    if (categoryResourceDate.status === web_core_esm.FETCH_STATUSES.FAILURE) {
      if (res) {
        res.statusCode = 404;
      }

      return {
        pageType: 'NOT_FOUND'
      };
    }

    await Promise.all([...(0,thunks/* getSharedThunkList */.q)(store.dispatch)]);
    return {
      pageType: 'CATALOG_PAGE',
      category: categoryResourceDate.data
    };
  } catch (error) {
    return {
      pageType: 'ERROR_PAGE',
      error
    };
  }
};

/***/ }),

/***/ 22894:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/[...alias]",
      function () {
        return __webpack_require__(6386);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,741,989,455,880,605,774,888,179], function() { return __webpack_exec__(22894); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);